/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkforceContractModel = {
    CostPlus: 'COST_PLUS',
    FixedPrice: 'FIXED_PRICE'
} as const;
export type WorkforceContractModel = typeof WorkforceContractModel[keyof typeof WorkforceContractModel];


export function instanceOfWorkforceContractModel(value: any): boolean {
    for (const key in WorkforceContractModel) {
        if (Object.prototype.hasOwnProperty.call(WorkforceContractModel, key)) {
            // @ts-ignore
            if (WorkforceContractModel[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorkforceContractModelFromJSON(json: any): WorkforceContractModel {
    return WorkforceContractModelFromJSONTyped(json, false);
}

export function WorkforceContractModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkforceContractModel {
    return json as WorkforceContractModel;
}

export function WorkforceContractModelToJSON(value?: WorkforceContractModel | null): any {
    return value as any;
}

